import { Notice } from '@origo/origo-ui';
import styles from './VersionInfo.module.css';

interface NewVersionNoticeProps {
    onOpenChangelog: () => void;
    onDismiss: () => void;
}

export function NewVersionNotice({ onOpenChangelog, onDismiss }: NewVersionNoticeProps) {
    return (
        <Notice variant="info" className={styles.notice} onDismiss={onDismiss}>
            Ny versjon ({__APP_VERSION__}) er rullet ut.{' '}
            <button type="button" className={styles.noticeButton} onClick={onOpenChangelog}>
                Se hva som er nytt
            </button>
        </Notice>
    );
}
